import { BasicUseDocument, NotificationTopic, UserSettings } from '@hb/shared'
import { useMemo } from 'react'
import { defaultNotificationSound, notificationSounds } from '../constants'

export const useMyMessageSound = (
  settings: BasicUseDocument<UserSettings>,
  topic: NotificationTopic,
) => {
  const { data: settingsData } = settings ?? {}
  const customValue = useMemo(
    () => settingsData?.notifications?.sounds?.[topic],
    [settingsData, topic],
  )

  return useMemo(() => {
    if (!customValue) return notificationSounds[defaultNotificationSound]
    if (!notificationSounds[customValue]) return notificationSounds[defaultNotificationSound]
    return notificationSounds[customValue]
  }, [customValue])
}
